module.exports = __webpack_public_path__ + "static/media/balconyblue.6addee5b.svg";